import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 2.25C3.19891 2.25 3.38968 2.32902 3.53033 2.46967C3.67098 2.61032 3.75 2.80109 3.75 3V3.54L5.588 3.08C7.8459 2.51546 10.2313 2.77723 12.313 3.818L12.421 3.872C14.1472 4.7352 16.1213 4.96592 18 4.524L21.11 3.792C21.2266 3.76464 21.3481 3.76563 21.4643 3.79487C21.5805 3.82411 21.688 3.88076 21.7778 3.96008C21.8676 4.03939 21.9371 4.13906 21.9804 4.25074C22.0238 4.36243 22.0398 4.48288 22.027 4.602C21.6549 8.03771 21.6565 11.5037 22.032 14.939C22.052 15.1211 22.0047 15.3042 21.8989 15.4538C21.7932 15.6034 21.6363 15.7091 21.458 15.751L18.344 16.484C16.1236 17.0066 13.7903 16.7341 11.75 15.714L11.642 15.66C9.88071 14.7793 7.86247 14.5576 5.952 15.035L3.75 15.585V21C3.75 21.1989 3.67098 21.3897 3.53033 21.5303C3.38968 21.671 3.19891 21.75 3 21.75C2.80109 21.75 2.61032 21.671 2.46967 21.5303C2.32902 21.3897 2.25 21.1989 2.25 21V3C2.25 2.90151 2.2694 2.80398 2.30709 2.71299C2.34478 2.62199 2.40003 2.53931 2.46967 2.46967C2.53931 2.40003 2.62199 2.34478 2.71299 2.30709C2.80398 2.2694 2.90151 2.25 3 2.25Z"
        fill={colorValue}
      />
    </svg>
  );
};
